var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CheckIcon } from '@heroicons/react/24/solid';
import Button from '@web/components/layout/Button';
import { FirstStep } from '@web/components/Onboarding/Steps/FirstStep';
import { FourthStep } from '@web/components/Onboarding/Steps/FourthStep';
import { useUserContext } from '@web/contexts/User';
import { useWorkspaceCtx } from '@web/contexts/Workspace';
import { trpc } from '@web/lib/trpc';
import { Page } from '@web/pages/layout/Page';
import { dashboardUrl, onboardingUrl } from '@web/router/urls';
import { classNames } from '@web/utility';
import { useFilters } from '@web/utility/hooks/useFilters';
import { useNavigateTo } from '@web/utility/hooks/useNavigateTo';
import { OnboardingSteps } from '@workalizer/shared/enums';
import { useTranslation } from 'react-i18next';
export var OnboardingPage = function () {
    var t = useTranslation().t;
    var refetch = useUserContext().refetch;
    var users = useWorkspaceCtx().users;
    var navigateTo = useNavigateTo();
    var step = useFilters().step;
    var currentStep = step !== null && step !== void 0 ? step : OnboardingSteps.firstStep;
    var totalSteps = 2;
    var updateSubscriptionMutation = trpc.updateSubscription.useMutation();
    var handleNext = function () { return __awaiter(void 0, void 0, void 0, function () {
        var activeUsers, nextStep;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(currentStep === 1)) return [3 /*break*/, 2];
                    activeUsers = users.filter(function (user) { return user.isActive; }).length;
                    return [4 /*yield*/, updateSubscriptionMutation.mutateAsync({
                            quantity: activeUsers
                        })];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    if (currentStep < totalSteps) {
                        nextStep = currentStep + 1;
                        navigateTo({
                            pathname: onboardingUrl,
                            newFilters: { step: nextStep }
                        });
                    }
                    if (currentStep === totalSteps) {
                        refetch();
                        navigateTo({ pathname: dashboardUrl });
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var steps = [
        {
            count: 1,
            title: t('onboarding.page.orgUnitsAndUsers'),
            completed: currentStep >= 1
        },
        {
            count: 2,
            title: t('onboarding.page.finish'),
            completed: currentStep >= 2
        }
    ];
    var returnCurrentStepPage = function () {
        switch (currentStep) {
            case OnboardingSteps.firstStep:
                return _jsx(FirstStep, {});
            case OnboardingSteps.secondStep:
                return _jsx(FourthStep, {});
            default:
                return null;
        }
    };
    return (_jsxs(Page, { children: [_jsx("div", __assign({ className: "text-3xl font-bold mb-3" }, { children: _jsx("h1", { children: t('onboarding.page.quickSetup') }) })), currentStep !== 0 && (_jsx("div", __assign({ className: "w-full min-h-[72px] mb-2.5 rounded-md border border-gray-300 justify-start items-center inline-flex flex-wrap" }, { children: steps.map(function (currStep) { return (_jsxs("div", __assign({ className: classNames('grow shrink basis-0 h-[72px] px-3 py-2 sm:px-6 sm:py-4 justify-start items-center gap-2 sm:gap-4 flex text-xs sm:text-sm font-medium leading-none', currentStep === currStep.count
                        ? 'text-indigo-600'
                        : 'text-gray-500') }, { children: [_jsx("div", __assign({ className: classNames('w-5 h-5 sm:w-10 sm:h-10 rounded-[20px] border-2 flex-col justify-center items-center inline-flex', currentStep === currStep.count ? 'border-indigo-600' : '', currStep.completed ? 'bg-indigo-600 border-indigo-600' : '', !currStep.completed && currentStep > currStep.count
                                ? 'border-gray-500'
                                : '') }, { children: currStep.completed ? (_jsx(CheckIcon, { className: "w-2 h-2 sm:w-5 sm:h-5 text-center\ttext-white" })) : (_jsx("div", { children: currStep.count })) })), currStep.count !== totalSteps ? (_jsx("button", __assign({ onClick: function () {
                                navigateTo({
                                    pathname: onboardingUrl,
                                    newFilters: { step: currStep.count }
                                });
                            }, className: "hover:text-indigo-800" }, { children: currStep.title }))) : (currStep.title)] }), currStep.count)); }) }))), returnCurrentStepPage(), currentStep === totalSteps ? (_jsx("div", __assign({ className: "flex justify-end" }, { children: _jsx(Button, __assign({ variant: "primary", onClick: handleNext }, { children: t('onboarding.page.next') })) }))) : (_jsx("div", __assign({ className: classNames('flex justify-end', currentStep === 0 ? 'hidden' : 'flex') }, { children: _jsxs("div", __assign({ className: "flex gap-3 lg:pr-2" }, { children: [_jsx(Button, __assign({ variant: "white", onClick: function () { return navigateTo({ pathname: dashboardUrl }); } }, { children: t('onboarding.page.skip') })), _jsx(Button, __assign({ variant: "primary", onClick: handleNext }, { children: t('onboarding.page.next') }))] })) })))] }));
};
